// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__OyG33","content":"styles_content__mnOj6","selectAll":"styles_selectAll__21L0L"};